export const paymentTypes = (state) => state.paymentTypes
export const paymentStatus = (state) => state.paymentStatus
export const paymentConditions = (state) => state.paymentConditions
